export default __webpack_public_path__ + "static/media/Hape-Bumblebee-pram-rattle_2.f3f1b0d1.jpg";